import { Box } from '@fhs-legacy/universal-components';

export const StyledTipErrorMessage = Box.withConfig({
  marginTop: '$0.5',
  _text: {
    color: Styles.color.error,
    fontSize: '2xs',
  },
});
